interface SectionHeaderProps {
  className?: string;
  /** Section title, e.g. "Как это работает" */
  title: string;
  /** Section subtitle */
  subtitle?: string;
  /** Heading tag for the title. Defaults to "h2". Use "h1" for page-level headers. */
  as?: "h1" | "h2";
}

/** Reusable section header — used by all landing sections */
export function SectionHeader({ className = "", title, subtitle, as: TitleTag = "h2" }: SectionHeaderProps) {
  return (
    <div className={`flex flex-col items-center gap-[16px] text-center max-w-[700px] w-full px-[20px] max-desktop:px-[20px] ${className}`}>
      <TitleTag
        className="[font-family:var(--font-commissioner)] font-bold not-italic text-[40px] leading-[48px] text-[rgba(0,0,0,0.9)] tracking-[-0.8px] max-tablet:text-[28px] max-tablet:leading-[36px] max-tablet:tracking-[-0.56px]"
        style={{ fontVariationSettings: '"FLAR" 0, "VOLM" 0' }}
      >
        {title}
      </TitleTag>
      {subtitle && (
        <p
          className="[font-family:var(--font-commissioner)] font-normal not-italic text-[18px] leading-[24px] text-black tracking-[-0.36px] max-tablet:text-[14px] max-tablet:leading-[20px] max-tablet:tracking-[-0.28px]"
          style={{ fontVariationSettings: '"FLAR" 0, "VOLM" 0' }}
        >
          {subtitle}
        </p>
      )}
    </div>
  );
}
